import { render, staticRenderFns } from "./privacy-view.html?vue&type=template&id=09622845&scoped=true&"
import script from "./privacy-view.js?vue&type=script&lang=js&"
export * from "./privacy-view.js?vue&type=script&lang=js&"
import style0 from "./privacy-view.css?vue&type=style&index=0&id=09622845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09622845",
  null
  
)

export default component.exports